// Algolia Search Configuration
// Get your free Algolia credentials at https://www.algolia.com/
// Free tier: 10K searches/month, 10K records

import { liteClient as algoliasearch } from 'algoliasearch/lite';

// Environment-based configuration
// Add these to your .env file:
//   VITE_ALGOLIA_APP_ID=your_app_id
//   VITE_ALGOLIA_SEARCH_KEY=your_search_only_api_key
//   VITE_ALGOLIA_INDEX_NAME=fash_products

const ALGOLIA_APP_ID = import.meta.env.VITE_ALGOLIA_APP_ID || '';
const ALGOLIA_SEARCH_KEY = import.meta.env.VITE_ALGOLIA_SEARCH_KEY || '';
export const ALGOLIA_INDEX_NAME = import.meta.env.VITE_ALGOLIA_INDEX_NAME || 'fash_products';

// Check if Algolia is configured
export const isAlgoliaConfigured = Boolean(ALGOLIA_APP_ID && ALGOLIA_SEARCH_KEY);

// Initialize client (returns null if not configured)
export const searchClient = isAlgoliaConfigured
  ? algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY)
  : null;

// Log configuration status in development
if (import.meta.env.DEV) {
  if (isAlgoliaConfigured) {
    console.log('Algolia search configured successfully');
  } else {
    console.log(
      'Algolia not configured. Using Firestore fallback search.\n' +
      'To enable Algolia, add VITE_ALGOLIA_APP_ID and VITE_ALGOLIA_SEARCH_KEY to .env'
    );
  }
}
